import { configureStore } from '@reduxjs/toolkit';
import uiReducer from '../features/ui/uiSlice';
import authReducer from '../features/auth/authSlice';
import { setUnauthorizedHandler } from '../services/apiClient';
import { logout } from '../features/auth/authSlice';
import { api } from '../services/api';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    auth: authReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefault) => getDefault().concat(api.middleware),
});

// A 401 means the token is expired, revoked, or the account was disabled —
// drop the session rather than leaving the UI in a half-signed-in state.
setUnauthorizedHandler(() => store.dispatch(logout()));
